import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { Link, useLocation } from '@/lib/router-compat';
import { scrollToContact } from '@/lib/navigation';

type ContactLinkProps = Omit<ComponentPropsWithoutRef<typeof Link>, 'to'>;

/** Native navigation before hydration, with the existing router once ready. */
const ContactLink = forwardRef<HTMLAnchorElement, ContactLinkProps>(function ContactLink(
  { onClick, ...props }, ref,
) {
  const { pathname, search, hash } = useLocation();
  const to = pathname === '/' ? `/${search}#contact` : '/#contact';

  return (
    <Link
      {...props}
      ref={ref}
      to={to}
      onClick={(event) => {
        onClick?.(event);
        // Preserve native new-tab/window/download behavior and caller cancellation.
        if (event.defaultPrevented || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
          (event.currentTarget.target && event.currentTarget.target !== '_self') ||
          event.currentTarget.hasAttribute('download')) return;

        if (pathname === '/' && hash === '#contact') {
          event.preventDefault();
          // Native fragment links can update the address without notifying the router.
          if (window.location.hash !== '#contact') {
            window.history.replaceState(window.history.state, '', '#contact');
          }
          scrollToContact();
        }
      }}
    />
  );
});

export default ContactLink;
